import { __awaiter, __generator } from "tslib";
import { fetchProduct } from '../product-catalogue/fetch-product';
import { getPricingApiConfig } from './config/actions';
import { fetchPricesGetByIds, fetchPricesGetBySkus } from './http';
export var fetchProductPrice = function (productId) { return __awaiter(void 0, void 0, void 0, function () {
    var isSFCCPricingOn, price, productSku, _a, prices;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                isSFCCPricingOn = getPricingApiConfig().isSFCCPricingOn;
                if (!isSFCCPricingOn) return [3 /*break*/, 5];
                return [4 /*yield*/, fetchProduct(productId)];
            case 1:
                productSku = (_b = (_c.sent())) === null || _b === void 0 ? void 0 : _b.sku;
                if (!productSku) return [3 /*break*/, 3];
                return [4 /*yield*/, fetchPricesGetBySkus([productSku])];
            case 2:
                _a = _c.sent();
                return [3 /*break*/, 4];
            case 3:
                _a = null;
                _c.label = 4;
            case 4:
                price = _a;
                return [3 /*break*/, 7];
            case 5: return [4 /*yield*/, fetchPricesGetByIds([productId], "p" /* Product */)];
            case 6:
                prices = _c.sent();
                price = (prices === null || prices === void 0 ? void 0 : prices[0]) || null;
                _c.label = 7;
            case 7: return [2 /*return*/, price];
        }
    });
}); };
